(function () {
  function initStickySingleFix() {
    var stickyBtn = document.querySelector('.sticky-atc-box button');
    var singleBar = document.querySelector('[data-deal-bar-id="cz5E"] .kaching-bundles__bar-main');
    var submitBtn = document.querySelector('[id^="ProductSubmitButton-"]');

    if (!stickyBtn || !singleBar || !submitBtn) return;
    if (stickyBtn.dataset.singleFixInit === 'true') return;

    stickyBtn.dataset.singleFixInit = 'true';

    stickyBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        singleBar.click();

        setTimeout(function () {
          submitBtn.click();
        }, 300);
      },
      true
    );
  }

  function startStickySingleFix() {
    initStickySingleFix();

    var observer = new MutationObserver(function () {
      initStickySingleFix();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startStickySingleFix);
  } else {
    startStickySingleFix();
  }
})();